export const DIN_PATH = "/declaraciones_de_ingresos";

export const DIN_EXCLUDED_DOCUMENT_CODES = [
  "0", "1", "33", "34", "35", "39", "41", "43", "46", "52", "56", "61", "110", "111", "112",
];

export const isDinPath = (pathname) => pathname === DIN_PATH;

export const getDinForm = (data) => data?.meta?.din?.form || "-";

/** DINs desde SII vienen en CLP sin meta.rate; las legacy TGR usan USD × rate. */
const isDinClp = (data) => {
  if (data?.currencyType === "CLP") return true;
  const rate = data?.meta?.rate;
  return rate == null || rate === "" || Number(rate) === 1;
};

const toClpAmount = (data, metaKey) => {
  const value = data?.meta?.[metaKey] || 0;
  if (isDinClp(data)) return Math.round(value);
  const rate = data?.meta?.rate || 1;
  return Math.round(value * rate);
};

export const getDinTaxAmount = (data) => toClpAmount(data, "taxAmount");

export const getDinNetAmount = (data) => toClpAmount(data, "netAmount");

export const getDinOriginalAmount = (data) => toClpAmount(data, "originalAmount");

export const getDinPaymentDate = (data) => {
  if (data?.meta?.isPaid === true) {
    return data?.meta?.paymentDate || data?.paymentDate;
  }
  return null;
};

export const getDinIssuedDate = (data) => data?.meta?.issuedAt;
